import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import BASE_URL from "../Services/BASE_URL";

export const investorApi = createApi({
  reducerPath: "investorApi",
  baseQuery: fetchBaseQuery({ baseUrl: BASE_URL }),
  endpoints: (builder) => ({
    getInvestorSections: builder.query({
      query: () => "/investor/sections",
    }),
  }),
});

export const { useGetInvestorSectionsQuery, useLazyGetInvestorSectionsQuery } =
  investorApi;
